import Cookies from 'js-cookie';
import React, { createContext, useContext, useState, useEffect } from 'react';

interface AuthContextType {
  token: string | null;
  setToken: (token: string | null) => void;
  isAuthenticated: boolean;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [token, setToken] = useState<string | null>(() => Cookies.get('token') || null);

  // Sync cookie whenever token state changes
  useEffect(() => {
    if (token) {
      Cookies.set('token', token);
    } else {
      Cookies.remove('token');
    }
  }, [token]);

  const isAuthenticated = !!token;

  return <AuthContext.Provider value={{ token, setToken, isAuthenticated }}>{children}</AuthContext.Provider>;
};

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
